module.exports = __webpack_public_path__ + "static/media/pc-bloqueo.7d099693.svg";